<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.0001 20.5H3.00006V22H21.0001V20.5Z" fill="currentColor" />
    <path
      d="M18.1901 12.53L17.1301 11.47L12.7101 15.89V3H11.3001V15.9L6.87006 11.47L5.81006 12.53L12.0001 18.72L18.1901 12.53Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "AudioIcon"
}
</script>
